import React from "react";
import NoIndex from '../../components/NoIndex';
import Styles from './styles.module.css';

const Pages404: React.FC = () => {

  return (
    <>
    <NoIndex title="ページが見つかりません | memorii works" />
    <div className={Styles.container}>
      <h1 className={Styles.h1}>404</h1>
      <p className={Styles.p}>お探しのページは見つかりませんでした。</p>

      <button className={Styles.button}
      onClick={() => {
        window.location.href = "https://memorii-works.com/";
      }}>ホームに戻る</button>
    </div>
    </>
  );
}

export default Pages404;
